import updateSession from './update-session';

export default {
  updateSession,
};
